module.exports = __webpack_public_path__ + "static/media/schwangerschaft_und_geburt.006b8432.jpg";